import { registerDecorator, ValidationOptions, ValidationArguments } from 'class-validator';
import moment from 'moment';

export function IsSameOrBeforeNow(validationOptions?: ValidationOptions) {
   return function (object: Object, propertyName: string) {
        registerDecorator({
            name: 'isSameOrBeforeNow',
            target: object.constructor,
            propertyName: propertyName,
            options: validationOptions,
            validator: {
                validate(value: any, args: ValidationArguments) {
                    const date = moment(value);
                    if (date.isValid()) {
                        const now = moment();
                        const isSameOrBefore = date.isSameOrBefore(now);
                        return isSameOrBefore;
                    }
                    return false;
                }
            }
        });
   };
}
